import repository from './repository'

const resource = 'app-bar-img'

export default {
  background (name) {
    return repository.get(`${resource}/${name}`)
  },
}
